(function () {
    'use strict';

    angular
        .module('app.core')
        .decorator('localStorageService', localStorageServiceDecorator);

    localStorageServiceDecorator.$inject = ['$delegate', '$window', 'memoryStorage'];
    function localStorageServiceDecorator($delegate, $window, memoryStorage) {
        if (!$delegate.isSupported) {
            $window.memoryStorage = memoryStorage;
            $delegate.setStorageType('memoryStorage');
        }
        return $delegate;
    }

})();